import {
  SHOP_LOGIN_PATH,
  TRANSFORM_URL_TO_MAIN,
  TRANSFORM_URL_TO_MAIN_AUTO
} from '@constant'
import http, { configure } from '@core/fetch'
import { getUrlParam } from '@core/utils'
import { setCookie } from '@hlj/hlj-utils'
import {
  __JTI__,
  __JWT__,
  __MAIN_JTI__,
  __MAIN_JWT__
} from '@merchant-backend/constant'
import { getJti, getRequestUrl, isSiDaTeam } from '@util'

/**
 * 项目进入时顶层鉴权流程
 */
class Store {
  setUp = () => {
    return new Promise(async resolve => {
      let jwtData = null
      const { isUrlJtiEqualToStorage, jti, isMainMerchant } = this.getUrlInfo()
      // url 上没有 jti，直接取本地的 jwt
      if (!jti) {
        jwtData = this.getJwtFromStorage(isMainMerchant)
      } else {
        // url 上有 jti，和本地存储的 jti 比对，如果不同，则重新获取 jwt
        // 从父级商家（或四大团队）登录进来时，此时也进入重新获取 jwt 逻辑
        if (!isUrlJtiEqualToStorage) {
          jwtData = await this.getTokenFromJti()
          // 设备不信任跳到验证
          if (!jwtData.token) {
            window.location.href = `${SHOP_LOGIN_PATH}?jti=${jti}&validation=true`
            return
          }
          this.setStorage(jwtData, jti, jwtData.parentStatus == 1)
        } else {
          jwtData = this.getJwtFromStorage(isMainMerchant)
        }
      }

      this.setHttp(jwtData)

      resolve(jwtData)
    })
  }

  setStorage = (jwtData, jti, isMainMerchant = false) => {
    const jwtKey = isMainMerchant ? __MAIN_JWT__ : __JWT__
    const jtiKey = isMainMerchant ? __MAIN_JTI__ : __JTI__
    // 未注册账户跳转至商家中心不会携带jti解析该参数，因此需要判断一下,这个逻辑后续盘古注册需要优化
    localStorage.setItem('isMainMerchant', isMainMerchant)
    localStorage.setItem(jwtKey, JSON.stringify(jwtData))
    localStorage.setItem(jtiKey, jti)
  }

  getJwtFromStorage = (isMainMerchant = false) => {
    const key = isMainMerchant ? __MAIN_JWT__ : __JWT__
    return JSON.parse(localStorage.getItem(key) || '{}')
  }

  getJtiFromUrl = () => {
    return getUrlParam('jti')
  }

  /**
   * url 上有 isParent=1 表示是四大团队登录进来
   * url 上有 superLogin=1 表示从四大团队/父账号登录进来
   */
  getUrlInfo = () => {
    const isParent = /isParent/.test(window.location.hash)
    const superLogin = /superLogin/.test(window.location.hash)
    const jti = this.getJtiFromUrl()
    const phone = getUrlParam('phone')
    return {
      isUrlJtiEqualToStorage: getJti(isParent) == jti,
      jti,
      isMainMerchant: isParent || isSiDaTeam(),
      superLogin,
      phone
    }
  }

  getTokenFromJti = async () => {
    const jti = this.getJtiFromUrl()

    const { data } = await http(
      getRequestUrl(
        '/hms/hljMerchantCenter/appApi/authorize/token/exchange',
        // eslint-disable-next-line
        __JAVA__DOMAIN__,
        true
      ),
      {
        body: {
          token: jti
        },
        headers: {
          platform: 'hljMerchant'
        }
      }
    )

    return data
  }

  setHttp = jwtData => {
    const { token, parentStatus } = jwtData || {}
    const isMain = parentStatus == 1

    configure({
      config: config => {
        if (token) {
          config.headers['Auth'] = token
          setCookie('auth', token)
        }

        return config
      },
      transformUrl: url => {
        // 若全链接则不走拼接处理
        if (!/^(https:|http:)?\/\//.test(url)) {
          // java 接口在打包时统一拼接域名
          if (url.indexOf('/hms/') > -1) {
            // eslint-disable-next-line
            url = getRequestUrl(url, __JAVA__DOMAIN__, true)
          } else if (url.indexOf('/hps/') > -1) {
            // eslint-disable-next-line
            url = getRequestUrl(url, __NEW__PHP_DOMAIN__, true)
          }
        }
        if (isMain) {
          let _url = ''
          const keys = Object.keys(TRANSFORM_URL_TO_MAIN)
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if (url.indexOf(key) > -1) {
              _url = url.replace(key, TRANSFORM_URL_TO_MAIN[key])
              break
            }
          }

          if (_url) {
            return _url
          }

          if (TRANSFORM_URL_TO_MAIN_AUTO.some(item => url.indexOf(item) > -1)) {
            return url.replace(/\/(admin|Admin|ShopAdmin)\//, '/mainAdmin/')
          }
        }

        return url
      }
    })
  }
}

export default Store
